/* eslint-disable max-len */
import { PolicyProductIdEnum } from 'outshared-lib';
import { CoverageGroupIdEnum } from '../enums';
import { CoverageGroupDataInterface } from '../interfaces';

export const coverageGroupData: CoverageGroupDataInterface[] = [
    {
        productId: PolicyProductIdEnum.Caravan,
        groups: [
            {
                groupId: CoverageGroupIdEnum.CaravanHail,
                title: 'Hagel Europa',
                tabs: [
                    {
                        active: 1,
                        id: 'wel-verzekerd',
                        title: 'Wel verzekerd',
                        body: "<p>Schade door hagel:<ul class='list'><li>Aan uw caravan</li><li>Aan uw inboedel als u deze heeft meeverzekerd</li><li>Aan uw extra’s (zoals voortent, luifel, antenne of schotel) als u deze heeft meeverzekerd</li></ul><p>Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat <a href='/documenten/download/voorwaarden-caravanverzekering.pdf' target='_blank'>in onze voorwaarden</a>.</p>",
                    },
                    {
                        active: 0,
                        id: 'niet-verzekerd',
                        title: 'Niet verzekerd',
                        body: "<p>Schade door hagel:</p><ul class='list'><li>Als u met uw caravan gaat rijden en er is gewaarschuwd voor storm of zwaar weer met kans op hagel of bliksem</li><li>In de periode van 1 december tot 1 maart als uw voortent beschadigd raakt door hagel</li></ul><p>Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat <a href='/documenten/download/voorwaarden-caravanverzekering.pdf' target='_blank'>in onze voorwaarden</a>.</p>",
                    },
                    {
                        active: 0,
                        id: 'eigen-risico',
                        title: 'Eigen risico',
                        body: "<p>€ 125,-</p><p><strong>LET OP:</strong> Heeft u geen Europadekking bij uw caravanverzekering afgesloten en krijgt u schade buiten de Benelux en Duitsland? Dan is uw eigen risico: € 1.500</p><p>Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat <a href='/documenten/download/voorwaarden-caravanverzekering.pdf' target='_blank'>in onze voorwaarden</a>.</p>",
                    },
                ],
            },
        ],
    },
    {
        productId: PolicyProductIdEnum.Travel,
        groups: [
            {
                groupId: CoverageGroupIdEnum.TravelMedicalCost,
                title: 'Medische kosten Wereld',
                tabs: [
                    {
                        active: 1,
                        id: 'wel-verzekerd',
                        title: 'Wel verzekerd',
                        body: "<ul class='list'><li>kosten van artsenbezoek en noodzakelijk vervoer</li><li>behandelingen en onderzoeken</li><li>medicijnen en hulpmiddelen</li><li>tandheelkundige kosten tot € 750</li><li>medische kosten voor hond of kat tot € 250</li></ul>",
                    },
                    {
                        active: 0,
                        id: 'niet-verzekerd',
                        title: 'Niet verzekerd',
                        body: "<p>Medische of tandheelkundige kosten:</p><ul class='list'><li>gemaakt tijdens werk</li><li>gemaakt tijdens zwangerschap (die bij de boeking al bekend was)</li><li>gemaakt bij ziekte (die bij de boeking al bekend was)</li><li>als u niet op reis gaat naar het buitenland maar in Nederland blijft.</li><li>als uw zorgverzekering geen vergoeding biedt in het land of de instelling waar u de medische kosten maakt.</li></ul>",
                    },
                    {
                        active: 0,
                        id: 'eigen-risico',
                        title: 'Eigen risico',
                        body: '<p>€250 eigen risico bij Medische kosten op reis</p>',
                    },
                ],
            },
        ],
    },
    {
        productId: PolicyProductIdEnum.Car,
        groups: [
            {
                groupId: CoverageGroupIdEnum.RoadsideAssistance,
                title: 'Pechhulp',
                subtitle: '<p>U kunt kiezen of u alleen Pechhulp in Nederland wilt of ook in de rest van Europa.',
                body: "<ul class='list'> <li> 24/7 hulp bij pech onderweg </li><li> Door betrouwbare Eurocross </li><li> Ook voor verloren sleutels en te laat tanken </li><li> Max. 7x per jaar bij pech </li><li> Max. 2x per jaar in uw woonplaats </li><li> Aanvullend af te sluiten bij onze uitgebreide en voordelige Autoverzekering </li></ul></p>",
            },
        ],
    },
    {
        productId: PolicyProductIdEnum.Home,
        groups: [
            {
                groupId: CoverageGroupIdEnum.HomeComplete,
                title: 'Compleet',
                body: '<p>Aanvullende Compleetdekking</p><p>Uw spullen zijn verzekerd met de Compleetdekking als u, iemand uit uw gezin of uw huisdier iets omstoot of laat vallen. Ook buitenshuis in Nederland is schade aan film-, fotoapparatuur, sieraden muziekinstrumenten, duik-, paarden, golf- en hengelsportspullen verzekerd. De Compleetdekking geldt voor de afgesloten dekkingen (Inboedel, Opstal en Eigenaars-/huurdersbelang).</p><p>Maar let op: schade aan mobiele elektronica door vallen en stoten is niet verzekerd met Compleet. Daarvoor heeft u onze aparte Mobiele Elektronica dekking nodig.</p>',
            },
        ],
    },
];
